import { useAuthStore } from '@features/authentication/store/authStore';
import type { PermissionCode } from '@features/shared/constants/permissions';

/**
 * Hook to check if the current user has a specific permission.
 */
export function usePermission(permission: PermissionCode): boolean {
  return useAuthStore((s) => s.hasPermission(permission));
}

/**
 * Hook to check if the current user has ANY of the given permissions.
 */
export function useAnyPermission(permissions: PermissionCode[]): boolean {
  return useAuthStore((s) => permissions.some((p) => s.hasPermission(p)));
}
